export default async function urlToBase64(url: string): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    fetch(url)
      .then((response) => response.blob())
      .then((blob) => reader.readAsDataURL(blob))
      .catch(reject);

    reader.onerror = reject;
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
        return;
      }

      reject(
        new Error(`Unhandled result could not be resolved. Received: ${typeof reader.result}`),
      );
    };
  });
}
